import React from 'react';
import {Button, Card, Modal, ModalBody, ModalFooter, Form, Row, Col,Table} from '@themesberg/react-bootstrap';
import PropTypes from 'prop-types';
import label from 'enqc-utilities/src/label/Label'
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {currencyFormat, isEmpty, isResponseOk} from "enqc-utilities/src/utils/Utilities";
// import SpotLocationSelectionModal from "./SpotLocationSelectionModal";
import {CURRENCY_SYMBOL} from "../utils/Global";
import BaseComponent, {toasting} from "../pages/base/BaseComponent";
import WarningLabel from "./input/WarningLabel";
import Checkbox from "./input/Checkbox";
import ItemOption from "./input/ItemOption";

/*= (message, okCallback, cancelCallback) =>*/

export default class ExtendProductOrderInquiryModal extends BaseComponent {

    constructor(props){
        super(props);
        let validation = this.defaultValidation()
        let validationMessage = this.defaultValidationMessage()

        this.state = {
            show:false,
            company: props.company?props.company:{},
            orderItems:[],
            productSubscribes:props.productSubscribes?props.productSubscribes:[],
            selectedProductPackage:{},
            validation,
            validationMessage,
            spotLocationSelectionModal:false,
            selectedSpotLocation:{},
            paymentAttribute:{}
        }
    }

    defaultValidation = () =>{
        let validation = {};
        validation.company = true ;
        validation.productPackage = true ;
        validation.orderItems = true ;
        return validation ;
    }
    defaultValidationMessage = () =>{
        let validationMessage = {};
        validationMessage.company = "" ;
        validationMessage.productPackage = "" ;
        validationMessage.orderItems = "" ;
        return validationMessage ;
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchPaymentMediaAttribute((paymentAttribute)=>{
            this.setState({paymentAttribute})
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!=this.props){
            let show = this.props.show?this.props.show:false
            this.setState({show},async () => {
                if(show && !prevState.show){
                    let validation = this.defaultValidation()
                    let validationMessage = this.defaultValidationMessage()
                    let productSubscribes = this.props.productSubscribes?this.props.productSubscribes:[]
                    let orderItems = []
                    for (let productSubscribe of productSubscribes) {
                        let orderItem = {}
                        orderItem.productPackage = productSubscribe.productPackage
                        orderItem.spotLocation = productSubscribe.smartDevice.spotLocation
                        orderItem.allocatedDeviceId = productSubscribe.smartDevice.deviceId
                        orderItem.type = "EXTENSION"
                        orderItem.checked = false
                        let productPackages = await this.fetchProductPackages(orderItem.productPackage)
                        orderItem.productPackages = productPackages
                        orderItems.push(orderItem)
                    }
                    this.setState({
                        show:show,
                        company:this.props.company?this.props.company:{},
                        productSubscribes:productSubscribes,
                        selectedProductPackage:{},
                        orderItems:orderItems,
                        validation,
                        validationMessage
                    })
                }
            })
        }
    }

    async fetchProductPackages(productPackage){
        let selectedProduct = productPackage.product
        if(selectedProduct) {
            let response = await this.asyncGet(Endpoint.API.PRODUCT_PACKAGES, {
                params: {
                    "published": true,
                    productId: selectedProduct.id
                }
            }, null,  false, false)
            if (isResponseOk(response)) {
                let productPackages = response.data
                return productPackages
            }
            return []
        }
        return []
    }

    fetchPaymentMediaAttribute(callback){
        this.get(Endpoint.API.PAYMENT_MEDIA_ATTRIBUTE, {},null, (response)=>{
            if(isResponseOk(response)){
                callback(response.data)
            }
        },   false, false)
    }

    validateFormSubmit() {
        // await super.validateFormSubmit();
        let {show, company, orderItems, spotLocationSelectionModal, paymentAttribute,
            validation, validationMessage} = this.state
        let valid = true;
        validation = this.defaultValidation()
        validationMessage = this.defaultValidationMessage()
        if (isEmpty(company)) {
            validation.company = false
            validationMessage.company = label.PleaseSelectCompany
            valid = false;
        }

        if (isEmpty(orderItems) || orderItems.length===0) {
            validation.orderItems = false
            validationMessage.orderItems = label.PleaseAddAtLeastOneOrderItem
            valid = false;
        }
        valid = false
        for (let orderItem of orderItems) {
            if(orderItem.checked){
                valid = true
            }
        }
        if(!valid){
            validation.orderItems = false
            validationMessage.orderItems = label.PleaseAddAtLeastOneOrderItem
            alert(label.PleaseAddAtLeastOneOrderItem)
        }
        this.setState({validation, validationMessage}, () => {
            if(valid){
                this.submit()
            }
        })
    }

    submit(){
        let {company, orderItems} = this.state
        let {onCreateOrder, onClose} = this.props
        let form = new FormData()
        form.append("orderItemListGson", JSON.stringify(orderItems))
        this.props.showProcessing()
        this.post(Endpoint.API.PRODUCT_ORDER_CREATE_WITH_COMPANY+"/"+company.id, form, null, (res)=>{
            this.props.closeProcessing()
            if(isResponseOk(res)){
                let productOrder = res.data
                toasting.success(label.SucceedCreatingNewRegistration)
                if(onCreateOrder){
                    onCreateOrder(productOrder)
                }
            }else{
                toasting.error(res.message)
                if(onClose){
                    onClose()
                }
            }
        }, true, false)
    }

    render(){
        let {show, company, selectedProduct, selectedProductPackage, selectedSpotLocation,
            products, productPackages, orderItems, spotLocationSelectionModal, paymentAttribute,
            validation, validationMessage} = this.state
        let {onClose} = this.props

        let adminFee = paymentAttribute.adminFee?paymentAttribute.adminFee:0
        let taxPercent = paymentAttribute.taxPercent?paymentAttribute.taxPercent:0
        let taxAmount = 0
        let total = 0
        let totalAmount = 0
        orderItems.forEach((item)=>{
            let productPackage = item.productPackage
            if(item.checked) {
                total += productPackage.price
            }
        })
        taxAmount = (total+adminFee)*(taxPercent/100)
        totalAmount = total+taxAmount+adminFee

        return (
            <>
                <Modal
                    size="xl"
                    as={Modal.Dialog}
                    show={show}
                    centered={true}
                    backdrop={true}>
                    {super.render()}
                    <Modal.Header>
                        {label.ExtendSubscriptionPeriod}
                    </Modal.Header>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body className="p-0">
                                        <Table hover responsive>
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>{label.Product}</th>
                                                <th>{label.ProductPackage}</th>
                                                <th>{label.Description}</th>
                                                <th>{label.MonthPeriod}</th>
                                                <th style={{maxWidth:'210px'}}>{label.Location}</th>
                                                <th>{label.Price}</th>
                                                <th>{label.Select}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                orderItems.map((item, index) => (
                                                    <>
                                                        <tr key={item.id}>
                                                            <th scope="row">{index+1}</th>
                                                            <td>{item.productPackage.product.name}</td>
                                                            <td>
                                                                <ItemOption
                                                                    size="sm"
                                                                    hideOptionLabel={true}
                                                                    hideLabel={true}
                                                                    objects={item.productPackages}
                                                                    value={item.productPackage.id}
                                                                    callback={(productPackage) => {
                                                                        item.productPackage = productPackage
                                                                        orderItems[index] = item
                                                                        this.setState({orderItems})
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>{item.productPackage.description}</td>
                                                            <td>{item.productPackage.monthPeriod+" "+label.Month}</td>
                                                            <td style={{maxWidth:'210px'}} className="text-wrap">{item.spotLocation?item.spotLocation.fullAddress:""}</td>
                                                            <td>
                                                                {currencyFormat(item.productPackage.price, CURRENCY_SYMBOL)}
                                                            </td>
                                                            <td className="text-center">
                                                                <Checkbox
                                                                    onChange={(checked) => {
                                                                        item.checked = checked
                                                                        orderItems[index] = item
                                                                        this.setState({orderItems})
                                                                    }}
                                                                    checked={item.checked}/>
                                                            </td>
                                                        </tr>
                                                        {
                                                            index===orderItems.length-1?(
                                                                <>
                                                                    <tr>
                                                                        <th><WarningLabel show={validation.orderItems} message={validationMessage.orderItems} /></th>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td><h6>{label.AdminFee}</h6></td>
                                                                        <td><h6>{currencyFormat(adminFee, 'Rp')}</h6></td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th></th>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td><h6>{label.Tax}</h6></td>
                                                                        <td><h6>{currencyFormat(taxAmount, 'Rp')}</h6></td>
                                                                        <td></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th></th>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td><h5>{label.Total}</h5></td>
                                                                        <td><h5>{currencyFormat(totalAmount, 'Rp')}</h5></td>
                                                                        <td></td>
                                                                    </tr>
                                                                </>
                                                            ):null
                                                        }
                                                    </>
                                                ))
                                            }
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                    <Modal.Footer>
                        <Form.Group>
                            <Button
                                variant="warning"
                                onClick={e=>{
                                e.preventDefault()
                                this.setState({
                                    modal:false
                                }, () => {
                                    if(this.props.onClose!=null){
                                        this.props.onClose()
                                    }
                                })
                            }}>
                                {label.Cancel}
                            </Button>
                            &nbsp;
                            <Button
                                variant="success"
                                onClick={e=>{
                                e.preventDefault()
                                this.validateFormSubmit()
                            }}>
                                {label.ExtendPeriod}
                            </Button>
                        </Form.Group>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

ExtendProductOrderInquiryModal.propTypes = {
    show:PropTypes.bool.isRequired,
    company:PropTypes.object.isRequired,
    productSubscribes:PropTypes.array.isRequired,
    onClose:PropTypes.func.isRequired,
    onCreateOrder:PropTypes.func.isRequired
}
